<template>
    <div class="wave-loader" :class="[bemFacet]">
        <div class="wave-loader--wave"></div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('wave-loader'),
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/wave-loader/index.vue?3feae989